import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconVideo"><Path d="M2.75 7.75C2.75 6.09315 4.09315 4.75 5.75 4.75H12.25C13.9069 4.75 15.25 6.09315 15.25 7.75V16.25C15.25 17.9069 13.9069 19.25 12.25 19.25H5.75C4.09315 19.25 2.75 17.9069 2.75 16.25V7.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><Path d="M15.25 10L19.8028 7.72361C20.4677 7.39116 21.25 7.87465 21.25 8.61803V15.382C21.25 16.1253 20.4677 16.6088 19.8028 16.2764L15.25 14V10Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconVideo;
